var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/model/copyModel.ts";
import { createEvent, createStore } from 'effector';
export var copyFolder = createEvent({
  name: "copyFolder",
  sid: "-v8odz"
});
export var resetCopyFolder = createEvent('reset', {
  name: "resetCopyFolder",
  sid: "-lo87sx"
});
export var copiedFolder$ = createStore(null, {
  name: "copiedFolder$",
  sid: "u8qxuc"
}).on(copyFolder, function (_, value) {
  return value;
}).reset(resetCopyFolder);